export type IImageStyle = {
    label: string;
    options: string[];
    value?: string;
  };
  
  export const imageStyles: IImageStyle[] = [
    { label: "film", options: ["35mm film", "lomography film", "8mm film"] },
    { label: "detailed", options: ["photoreal", "detailed", "realistic"] },
    { label: "sketchy", options: ["drawing", "minimal", "illustration"] },
    { label: "illustration", options: ["digital", "3D", "sculpted"] },
    {
      label: "realistic",
      options: ["photoreal", "ultra-realistic", "hyper-realistic"],
    },
    {
      label: "lighting",
      options: ["soft lighting", "high contrast", "diffuse lighting"],
    },
    {
      label: "natural light",
      options: ["sunlight", "flash photography", "golden hour"],
    },
    { label: "peaceful", options: ["calm", "tranquil", "serene"] },
    { label: "cinematic", options: ["film noir", "still life", "realistic"] },
    {
      label: "portrait",
      options: [
        "headshot",
        "candid",
        "close-up portrait",
        "studio portrait",
        "fashion photography",
        "environmental portrait",
      ],
    },
    { label: "art style", options: ["impressionist", "cubist", "post-modern"] },
    { label: "minimal", options: ["white space", "minimal", "clean"] },
    { label: "simple", options: ["flat design", "simple", "basic"] },
    { label: "close up", options: ["extreme close-up", "macro", "magnified"] },
    { label: "colorful", options: ["vibrant colors", "saturated", "hot tones"] },
    {
      label: "color scheme",
      options: ["blue and orange", "yellow and purple", "pink and black"],
    },
    {
      label: "aesthetic",
      options: ["cyberpunk", "sci-fi aesthetic", "fantasy aesthetic"],
    },
    { label: "watercolor", options: ["aquarelle", "ink wash", "wet on wet"] },
    { label: "illustration", options: ["sketch", "painting", "digital art"] },
    { label: "charcoal", options: ["pencil", "pastels", "ink"] },
    { label: "dynamic", options: ["static", "high octane", "energetic"] },
    { label: "colorful", options: ["bold colors", "vibrant", "subdued"] },
    { label: "expressive", options: ["emotional", "joyful", "motionless"] },
    { label: "vintage", options: ["retro", "modern", "nostalgic"] },
    {
      label: "high contrast",
      options: ["low contrast", "medium contrast", "dramatic contrast"],
    },
    {
      label: "digital art",
      options: ["3D render", "digital painting", "digital art"],
    },
    {
      label: "3D render",
      options: ["3D model", "digital painting", "digital art"],
    },
    { label: "bokeh", options: ["out of focus", "dreamy bokeh", "shaped bokeh"] },
    { label: "photoreal", options: ["realistic", "hyper-realistic", "lifelike"] },
    {
      label: "painting",
      options: ["digital painting", "ink drawing", "oil painting"],
    },
    {
      label: "documentary",
      options: ["photojournalism", "street photo", "documentary photo"],
    },
    {
      label: "macro photo",
      options: ["wide angle", "telephoto", "bird's eye view"],
    },
    { label: "silhouette", options: ["shadow", "dramatic light", "rim light"] },
  
    {
      label: "DSLR",
      options: ["professional camera", "cinema camera", "camera lens"],
    },
  ];
  